<template>
    <div>
        <div class="p-4">
            <h2>Gerenciar usuários</h2>
            <p>Adicione, atualize ou exclua usuários</p>

            <div class="flex justify-content-end mb-4">
                <Button label="Adicionar Usuário" icon="pi pi-users" size="small" @click="visible = true" />
                <Button label="Excluir Usuários" icon="pi pi-trash" severity="danger" size="small" class="ml-3" :disabled="selectedUsers.length == 0"  @click="deleteUsers" />
            </div>

            <Dialog v-model:visible="visible" modal header="Adicionar Usuário" :style="{ width: '50vw' }"
                :breakpoints="{ '960px': '75vw', '641px': '95vw' }">
                <form @submit.prevent="inserirUsuario">
                    <InputText placeholder="Nome" v-model="novoUsuario.nome" required class="w-full mb-3 mt-1" />
                    <InputText placeholder="Email" v-model="novoUsuario.email" required class="w-full mb-3" />
                    <InputText placeholder="Url de imagem" v-model="novoUsuario.img" class="w-full mb-3" />
                    <Dropdown optionLabel="label" :options="funcoes" optionValue="value" placeholder="Função"
                        v-model="novoUsuario.funcao" required class="w-full mb-3" />
                    <Dropdown v-if="novoUsuario.funcao == 'estudante'" optionLabel="value" :options="generos" optionValue="value" placeholder="Gênero"
                            v-model="novoUsuario.genero" required class="w-full mb-3" />
                    <Dropdown v-if="novoUsuario.funcao == 'estudante'" optionLabel="label" :options="anos" optionValue="value" placeholder="Ano do Médio"
                                v-model="novoUsuario.ano" required class="w-full mb-3" />

                    <Dropdown v-if="novoUsuario.funcao == 'professor'" optionLabel="nome" :options="disciplinas" optionValue="id" v-model="novoUsuario.disciplina" placeholder="Disciplina" class="w-full mb-3"/>

                    <Button label="Adicionar " size="small" type="submit" :disabled="formularioValidado == false" />
                </form>
            </Dialog>
            <Toast />




        </div>

        <DataTable v-model:selection="selectedUsers" v-model:editingRows="editingRows" :value="usuarios" paginator :rows="10" v-model:filters="filters"
            editMode="row" dataKey="id" @row-edit-save="onRowEditSave" stripedRows>
            <template #header>
                <div class="flex justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Pesquisar usuário" />
                    </span>

                </div>
            </template>
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column field="img" header="Avatar">
                    <template #body="{ data, field }">
                        <Avatar :image="data[field]" class="mr-2" size="large" shape="circle"/>
                    </template>
                   
                </Column>
            <Column field="nome" header="Nome" sortable>
                <template #editor="{ data, field }">
                    <InputText v-model="data[field]" autofocus size="small" />
                </template>
            </Column>
            <Column field="email" header="Email" sortable>
                <template #editor="{ data, field }">
                    <InputText v-model="data[field]" autofocus size="small" />
                </template>
            </Column>
            <Column field="funcao" header="Função" sortable>
                <template #editor="{ data, field }">
                    <Dropdown v-model="data[field]" :options="funcoes" optionLabel="label" optionValue="value" autofocus
                        size="small" class="w-full" />
                </template>
            </Column>
            <Column field="genero" header="Gênero" sortalhe>
                <template #editor="{ data, field }">
                    <Dropdown v-model="data[field]" :options="generos" optionLabel="label" optionValue="value" autofocus :disabled="data.funcao != 'estudante'"
                        size="small" class="w-full" />
                </template>
            </Column>
            <Column field="ano" header="Ano" sortable>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="anos" optionLabel="label" optionValue="value" autofocus :disabled="data.funcao != 'estudante'"
                            size="small" class="w-full" />
                    </template>
            </Column>
            <Column header="Editar" :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center" >
            </Column>
        </DataTable>

    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { supabase } from '@/supabase';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { FilterMatchMode } from 'primevue/api';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Avatar from 'primevue/avatar';
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";

import store from '@/store';

import { carregarDisciplinas } from '@/api/fetchDisciplinas';


const toast = useToast();
const visible = ref(false);
const filters = ref({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } })
const editingRows = ref([])
const usuarios = ref([])
const disciplinas = ref([])


const formularioValidado = computed(() => {
    const { funcao, nome, email, genero, ano, disciplina } = novoUsuario.value;

    // Verifica se os campos comuns estão preenchidos
    if (!nome || !email || !funcao) {
        return false;
    }

    // Verifica campos específicos baseados na função do usuário
    if (funcao === 'estudante') {
        if(!genero || !ano) {
            return false
        }
    } else if (funcao === 'professor') {
       if(!disciplina) {
           return false
       }
    }

    return true;
})


const funcoes = ref([
    { label: "Adiministrador", value: "administrador" },
    { label: "Estudante", value: 'estudante' },
    { label: "Professor", value: 'professor' },
]);
const novoUsuario = ref({ nome: null, email: null, funcao: null, img: null, genero: null, ano: null, disciplina:null });
const generos = ref([
    { label: '',value: 'NULL' },
    { label: 'F', value: 'F' },
    { label: 'M', value: 'M' }
])
const anos = ref([
    { label: "", value: "NULL" },
    { label: "1° ano", value: "1" },
    { label: "2° ano", value: "2" },
    { label: "3° ano", value: "3" }
])
let selectedUsers = ref([]);

onMounted(async ()  => {
    let resultado = await carregarDisciplinas();
    if (resultado) {
        disciplinas.value = resultado
    }
    await buscaUsuarios();
   
})

const showToastAddUser = () => {
    toast.add({ severity: 'success', summary: 'Usuário', detail: 'O usuário foi adicionado com sucesso', life: 3000 });
};
const showToastErrorUser = () => {
    toast.add({ severity:"error", summary: 'Usuário', detail: 'Ocorreu um erro ao realizar a ação. Tente novamente', life: 3000 });
};

const inserirUsuario = async () => {
    const { error } = await supabase
        .from('users')
        .insert({ nome: novoUsuario.value.nome, email_teams: novoUsuario.value.email, email: novoUsuario.value.email, funcao: novoUsuario.value.funcao, img: novoUsuario.value.img, genero: novoUsuario.value.genero, ano: novoUsuario.value.ano })
    buscaUsuarios();
    
    
    if (error) {
        showToastErrorUser();
        console.log(error);
    }else{
        showToastAddUser()
        novoUsuario.value = { nome: null, email: null, funcao: null, img: null, genero: null, ano: null };
    }
};

const buscaUsuarios = async () => {
    const { data, error } = await supabase
        .from('users')
        .select('*')
        .order('nome')
    usuarios.value = data
    if(error){
      showToastErrorUser()  
    }
}

const onRowEditSave = async (event) => {
    let { newData } = event;
    
    const { data, error } = await supabase
        .from('users')
        .update(newData)
        .eq('id', newData.id)
        .select()
    if (error) {
         alert(error.message)
        return;
    }
    const index = usuarios.value.findIndex(usuario => usuario.id === newData.id);
    if (index !== -1 && data.length > 0) {
        usuarios.value[index] = data[0];
    }
};

const deleteUsers = async () => {
    let itemsToDelete = []
    selectedUsers.value.forEach(item => itemsToDelete.push(item.id))

    const { error } = await supabase
        .from('users')
        .delete()
        .in('id', itemsToDelete)
    selectedUsers.value = []
    buscaUsuarios()
    
    if(error){
         showToastErrorUser()
    }
}



const newUserEmails = ref([]);

async function loadNewUserEmails(){
    console.log('Emails de usuários')
    const {data, error} = await supabase
        .from('user_emails')
        .select('*')

    if(error){
        console.log(error);
        return;
    }


    newUserEmails.value = data;

    // const usuario = data[4];
    // await saveNewEmails(usuario.email, findUserId(usuario.nome))
    for(const usuario of data){
        await saveNewEmails(usuario.email, findUserId(usuario.nome))
    }
}


async function saveNewEmails(email, id){
    if(!id) return;

    const {data, error} = await supabase
        .from('users')
        .update({email_secundario: email})
        .eq('id', id)

        if(error){
            console.log(error);
            console.log('Erro no aluno ' + nome)
        }

    
}

function findUserId(nome) {
    const normalizedNome = normalizeName(nome);
    const nomeParts = normalizedNome.split(" ");

    if (nomeParts.length < 2) return undefined; // Se não houver pelo menos dois nomes, retorna undefined

    const firstName = nomeParts[0]; // Primeiro nome
    const lastName = nomeParts[nomeParts.length - 1]; // Último nome

    const id = usuarios.value.find(item => {
        const normalizedItem = normalizeName(item.nome).trim();
        return normalizedItem.includes(firstName.trim()) && normalizedItem.includes(lastName.trim());
    })?.id;

    return id;
}

function normalizeName(name) {


    return name.toUpperCase()
}

</script>